import React, {Component} from "react";
import { NavLink } from 'react-router-dom';
import './footer.css';


class Footer extends Component {

    /**
     * This method render the information with HTML code
     * @returns Return page information inside HTML
     */
    render() {
        return(
            <div className="footer">
                <ul>
                    <li><NavLink className="nav-item nav-link" exact to="/">Apoio Técnico</NavLink></li>
                    <li><NavLink className="nav-item nav-link" exact to="/">Contactos</NavLink></li>
                    <li><NavLink className="nav-item nav-link" exact to="/quemsomos">Sobre Nós</NavLink></li>
                </ul>
            </div>
        );
    }

}

export default Footer;
